let BASE_URL = "https://a.klaviyo.com",
  BIS_ENDPOINT = "/client/back-in-stock-subscriptions",
  LIST_ENDPOINT = "/client/subscriptions/";
class Klaviyo {
  constructor() {
    (this.publicKey = window.klaviyoFAV.key),
      (this.newsletterListId = window.klaviyoFAV.newsletterListId);
  }
  backInStockSubscribe({ email: s, variant: a, subscribe: n = !1 }) {
    return new Promise((i, e) => {
      var t = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: { data: { type: "profile", attributes: { email: s } } },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::" + a,
              },
            },
          },
        },
      };
      n && this.listSubscribe(s, this.newsletterListId);
      try {
        fetch("" + BASE_URL + BIS_ENDPOINT + "?company_id=" + this.publicKey, {
          method: "post",
          headers: {
            accept: "application/json",
            revision: "2024-05-15",
            "content-type": "application/json",
          },
          body: JSON.stringify(t),
        }).then((t) => {
          i(t);
        });
      } catch (t) {
        e(t);
      }
    });
  }
  listSubscribe(s, a) {
    return new Promise((i, e) => {
      var t = {
        data: {
          type: "subscription",
          attributes: {
            profile: { data: { type: "profile", attributes: { email: s } } },
          },
          relationships: { list: { data: { type: "list", id: a } } },
        },
      };
      try {
        fetch("" + BASE_URL + LIST_ENDPOINT + "?company_id=" + this.publicKey, {
          method: "post",
          headers: {
            revision: "2024-02-15",
            "content-type": "application/json",
          },
          body: JSON.stringify(t),
        }).then((t) => {
          i(t);
        });
      } catch (t) {
        e(t);
      }
    });
  }
}
